import { useRef, useState } from 'react';
import {
	useCzMaxPriceData,
	useCzMaxPriceReferenceBasketVersions,
	useCzMaxPriceReset as useCzMaxPriceResetMutation,
	useCzMaxPriceUpdate,
} from '~/libs/infrastructure/api/users/czMaxPrice';
import { ProductUpdate } from '~/libs/infrastructure/schemas/czMaxPrice';
import { Status } from '../components/czMaxPrice/ProductParametersPanel';

export interface SaveUpdate {
	packageSize: number | null;
	basketVersion: string;
	products: ProductUpdate[];
}

export function useCzMaxPriceDetail(userId: string, groupId: string) {
	const { data: czMaxPrice = null, isLoading: isFetching } = useCzMaxPriceData(userId, groupId);
	return { czMaxPrice, isFetching };
}

export function useCzMaxPriceBasketVersions() {
	const { data: basketVersions = null } = useCzMaxPriceReferenceBasketVersions();
	return { basketVersions };
}

export function useCzMaxPriceSave(userId: string, groupId: string) {
	const [updateSaveStatus, setUpdateSaveStatus] = useState<Status | null>(null);

	const mutation = useCzMaxPriceUpdate(userId, groupId, {
		onMutate: () => setUpdateSaveStatus(Status.saving),
		onSuccess: () => setUpdateSaveStatus(Status.saved),
		onError: () => setUpdateSaveStatus(Status.failed),
	});
	const mutationRef = useRef(mutation);
	mutationRef.current = mutation;

	return {
		save: (update: SaveUpdate) => mutationRef.current.mutate(update),
		saveAsync: (update: SaveUpdate) => mutationRef.current.mutateAsync(update),
		updateSaveStatus,
	};
}

export function useCzMaxPriceReset(userId: string, groupId: string) {
	const mutation = useCzMaxPriceResetMutation(userId, groupId);
	const mutationRef = useRef(mutation);
	mutationRef.current = mutation;

	return {
		reset: () => mutationRef.current.mutateAsync(),
	};
}
